import { channel } from "@tm/models"

export const AppChannel = channel("APP")
